<template>
  <div class="forestMsgPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <van-cell-group class="forestInput" v-if="!showNonePage">
      <van-field
        :value="
          baseData.xianName
            ? baseData.xianName
            : '' + baseData.xiangName
            ? baseData.xiangName
            : '' + baseData.cunName
            ? baseData.cunName
            : ''
        "
        readonly
        :label="$t('common.location') + '：'"
      />
      <van-field
        :value="baseData.entryName ? baseData.entryName : $t('common.noneText')"
        readonly
        :label="$t('common.speciesTit') + '：'"
      />
      <van-field
        :value="baseData.code ? baseData.code : $t('common.noneText')"
        readonly
        :label="$t('common.serialNumberTit') + '：'"
      />
      <van-field
        :value="baseData.treeAge ? baseData.treeAge : $t('common.noneText')"
        readonly
        :label="$t('common.treeAgeTit') + '(' + $t('common.year') + ')' + '：'"
      />
      <van-field
        :value="baseData.family ? baseData.family : $t('common.noneText')"
        readonly
        :label="$t('oldTree.keTit') + '：'"
      />
      <van-field
        :value="baseData.genus ? baseData.family : $t('common.noneText')"
        readonly
        :label="$t('oldTree.shuTit') + '：'"
      />
      <van-field
        :value="baseData.placeName ? baseData.placeName : $t('common.noneText')"
        readonly
        :label="$t('oldTree.diMingTit') + '：'"
      />

      <van-field
        :value="
          baseData.treeClasses ? baseData.treeClasses : $t('common.noneText')
        "
        readonly
        :label="$t('oldTree.gsDj') + '：'"
      />
      <van-field
        :value="
          baseData.treeHeight ? baseData.treeHeight : $t('common.noneText')
        "
        readonly
        :label="$t('oldTree.shuGaoTit') + '(' + $t('common.meter') + ')' + '：'"
      />
      <van-field
        :value="
          baseData.rodDiameter ? baseData.rodDiameter : $t('common.noneText')
        "
        readonly
        :label="
          $t('oldTree.xiongWeiTit') + '(' + $t('common.centimeter') + ')' + '：'
        "
      />
      <van-field
        :value="baseData.crown ? baseData.crown : $t('common.noneText')"
        readonly
        :label="$t('oldTree.guanFuTit') + '(' + $t('common.meter') + ')' + '：'"
      />
      <van-field
        :value="
          baseData.growthPotential
            ? baseData.growthPotential
            : $t('common.noneText')
        "
        readonly
        :label="$t('oldTree.trend') + '：'"
      />
      <van-field
        :value="
          baseData.management ? baseData.management : $t('common.noneText')
        "
        readonly
        :label="$t('oldTree.bhDw') + '：'"
      />
    </van-cell-group>
    <van-field
      value=" "
      readonly
      :label="$t('oldTree.history') + '：'"
      class="historyInput"
      v-if="!showNonePage"
    />
    <div
      class="historyMain"
      v-if="!showNonePage"
      v-html="baseData.historicCulture"
    ></div>
  </div>
</template>
<script>
/*eslint-disable*/

// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "oldTreeMsg",
  data() {
    return {
      showNonePage: true,
      treeId: "",
      baseData: {},
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.treeId = this.$route.query.commonId;
      if (this.treeId == undefined) {
        this.treeId = this.dataInfo.id;
      }
      this.initPage();
    });
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal.oldTree
        .oldTreeMsg(_this.treeId)
        .then((res) => {
          if (res.code == "1") {
            _this.showNonePage = false;
            _this.baseData = Object.assign({}, _this.baseData, res.data);
            _this.baseData.historicCulture = _this.baseData.historicCulture
              ? _this.baseData.historicCulture
              : "暂无";
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;

        _this.treeId = this.dataInfo.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.forestMsgPage {
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  .forestInput {
    .van-cell {
      .van-field__label {
        color: #666;
        font-size: 14px;
      }
      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }
      .van-cell__title {
        width: 120px;
      }
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
    .minRows.van-cell {
      overflow: initial;
      .van-field__body {
        textarea {
          min-height: 27px;
          text-align: right;
          text-align: justify;
        }
      }
    }
  }
  .historyInput {
    padding: 10px 16px 0;
    &:after {
      content: none;
    }
  }
  .historyMain {
    padding: 8px 16px 10px;

    p {
      color: #333;
      font-size: 14px;
      text-align: left;
      line-height: 22px;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>